import { render, staticRenderFns } from "./MessageResultForum.vue?vue&type=template&id=8ac540ce&scoped=true"
import script from "./MessageResultForum.vue?vue&type=script&lang=js"
export * from "./MessageResultForum.vue?vue&type=script&lang=js"
import style0 from "./MessageResultForum.vue?vue&type=style&index=0&id=8ac540ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ac540ce",
  null
  
)

export default component.exports